import React, { useEffect, useState } from 'react'
import ApiService from '../../functions/apiService';
import { useSelector } from 'react-redux';
import { Chip } from '@mui/material';
import MyTable from './MyTable';
import { getGridStringOperators } from '@mui/x-data-grid';
import moment from 'moment';
import SectionHeader from './SectionHeader';

export default function OffDutyTraining() {
  const [row, setRow] = useState([]);
  let data = useSelector((state) => state.dashboardReducer.Data)

  useEffect(() => {
    if (!data?.date) return;
    ApiService.get('/offDutyTraining/byDate', { date: data.date })
      .then((res) => {
        const list = Array.isArray(res) ? res : (res?.data?.data || res?.data || []);
        setRow((list || []).map((r, i) => ({ ...r, id: r?.id ?? r?.Id ?? `odt-${i}` })));
      })
      .catch(() => setRow([]));
  }, [data])

  const containsOnly = getGridStringOperators().filter(
    (operator) => operator.value === "contains"
  );

  const columns = [
    {
      field: "RequestDateEmployee",
      headerName: "Date",
      flex: 1,
      minWidth: 160,
      filterOperators: containsOnly,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{params?.row?.Request_Date ? moment(params.row.Request_Date).format('MM/DD/YYYY') : '—'}</span>
        </div>
      ),
    },
    {
      field: "Class_Name",
      headerName: "Class Name",
      flex: 1,
      minWidth: 180,
      filterOperators: containsOnly,
    },
    {
      field: "TrainingTime",
      headerName: "Start / End Time",
      flex: 1,
      minWidth: 140,
      filterOperators: containsOnly,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{params?.row?.Training_Start_Time || '—'}</span>
          <span>{params?.row?.Training_End_Time || '—'}</span>
        </div>
      ),
    },
    {
      field: "PaidInfo",
      headerName: "Payment Info",
      flex: 1,
      minWidth: 160,
      filterOperators: containsOnly,
      renderCell: (params) => {
        const isPaid = params?.row?.Is_Paid;
        const paymentType = params?.row?.Payment_Type;
        const formattedType = paymentType
          ? paymentType.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
          : "NA";
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{isPaid ? "Paid" : "Unpaid"}</span>
            <span>{isPaid ? formattedType : "NA"}</span>
          </div>
        );
      },
    },
    {
      field: "Training_Location",
      headerName: "Location",
      flex: 1,
      minWidth: 160,
      filterOperators: containsOnly,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      filterOperators: containsOnly,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          sx={{
            backgroundColor: params.value === 'Pending'
              ? 'rgba(255, 165, 0, 0.16)'
              : params.value === 'Approved'
                ? 'rgba(1, 120, 79, 0.1)'
                : 'rgba(230, 39, 25, 0.1)',
            color: params.value === 'Pending'
              ? '#FF8C00'
              : params.value === 'Approved'
                ? 'rgba(1, 120, 79, 1)'
                : '#ff0000',
            border: params.value === 'Pending'
              ? '1px solid rgba(255, 165, 0, 0.28)'
              : params.value === 'Approved'
                ? '1px solid rgba(1, 120, 79, 1)'
                : '1px solid rgba(230, 39, 25, 0.4)',
          }}
        />
      ),
    },
    {
      field: "Action_By",
      headerName: "Action By",
      flex: 1,
      minWidth: 130,
      filterOperators: containsOnly,
      renderCell: (params) => <span>{params?.row?.action_by_employee?.fullName || '—'}</span>,
    },
  ];

  return (
    <div>
      {row && row.length > 0 &&
        <div className='m-3 pb-2'>
          <SectionHeader title="Off Duty Training" count={row.length} />
          <MyTable
            rows={row}
            columns={columns}
            useTopFilter={false}
            hideFooter={true}
            checkboxSelection={false}
          />
        </div>
      }
    </div>
  )
}
